<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body" v-if="!optionList.length">
      無配料，請新增
    </div>
    <div class="box-body" v-else>
      <div class="col-xs-12">
        <div class="inline-block pull-left">
          <h4 class="pull-left">
          配料
          </h4>
        </div>
        <div>
          <button class="btn btn-danger m-y-10 inline-block pull-right" data-toggle="modal" data-target="#delModal" @click="delModalOpen">
            刪除
          </button>
          <button
            class="btn btn-default btn-black m-y-10 inline-block pull-right m-r-10"
            @click="goCrOptions"
          >
            新增
          </button>
          <button class="btn btn-default btn-black m-y-10 inline-block pull-right m-r-10" data-toggle="modal" @click="show.easy = !show.easy">
            <span v-if="!show.easy">簡易</span>
            <span v-else>進階</span>
          </button>
          <button class="btn btn-primary m-y-10 pull-right m-r-10 " data-toggle="modal" @click="copyOption">複製配料</button>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="col-xs-12 col-md-2 bg-light-gray select-element-block text-left">
          <div
            v-for="(option, index) in optionList"
            :key="index"
            class="select-element"
            :class="{'active': curId === option.item_id}"
            @click="clickOption(option, index)"
            :disabled="curId === adjust.item_id"
          >
            <span class="text-w-600">
              {{ option.name }}
            </span>
            <small style="opacity: .7;">
              {{ option.remark }}
            </small>
          </div>
        </div>

        <div class="col-xs-12 col-md-10">
          <div class="box-body form menu-form col-xs-12">
            <div class="col-xs-12 col-md-6 p-r-5">
              <div class="input-group">
                <span class="input-group-addon">
                  <span class="text-red">＊</span>
                  類型
                </span>
                <div class="form-group">
                  <select class="form-control" v-model="optionInfo.sub_type">
                    <option v-for="option in subTypeList" :value="option.value">{{option.label}}</option>
                  </select>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>配料名稱</span>
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.name" maxlength="32">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>排序</span>
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.sort" @keyup="veritySort()" maxlength="4" ref="sort">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>選購數量</span>
                <div>
                  <input style="width: calc(50% - 10px)" class="c-auto form-control" placeholder="請輸入數量" type="text" @keyup="verityMinLimit()" v-model="optionInfo.min_limit" maxlength="9" ref="minLimit">
                  <span class="pull-left" style="line-height: 38px; width: 20px">~</span>
                  <input style="width: calc(50% - 10px)"  class="c-auto form-control" placeholder="請輸入數量" type="text" @keyup="verityMaxLimit()" v-model="optionInfo.max_limit" maxlength="9" ref="maxLimit">
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>價格</span>
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.price" @keyup="verityPrice()" maxlength="9" ref="price">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>必選項目</span>
                <div class="radio text-left h-38" style="border-left: 1px solid #d2d6de;">
                  <label class="m-l-15">
                    <input type="radio" name="mandatoryRadio" :value="1" v-model="optionInfo.is_mandatory" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">是</div>
                  </label>
                  <label class="m-l-15">
                    <input type="radio" name="mandatoryRadio" :value="0" v-model="optionInfo.is_mandatory" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">否</div>
                  </label>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">備註</span>
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.remark" maxlength="45">
              </div>
              <br>
            </div>
            <div class="col-xs-12 col-md-6 p-l-5" v-show="!show.easy">
              <!-- 進階 -->
              <!--<div><hr>進階</div>-->
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>常見價格</span>
                <div class="radio text-left h-38" style="border-left: 1px solid #d2d6de">
                  <label class="m-l-15">
                    <input type="radio" name="commonRadio" :value="1" v-model="optionInfo.is_common" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">是</div>
                  </label>
                  <label class="m-l-15">
                    <input type="radio" name="commonRadio" :value="0" v-model="optionInfo.is_common" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">否</div>
                  </label>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>價格類型</span>
                <div class="form-group">
                  <select class="form-control" v-model="optionInfo.price_type" >
                    <option :value="1">免稅價格</option>
                    <option :value="3">含稅價格</option>
                  </select>
                </div>
              </div>
              <!--<div class="text-right text-15 text-red">(若無價格則無須更動)</div>-->
              <br />
              <div class="input-group">
                <span class="input-group-addon">熱量</span>
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.calorie" @keyup="verityCalorie()" ref="calorie">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">描述</span>
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.description" maxlength="45">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">商品料號</span>
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.vendor_custom_id" maxlength="30">
              </div>
              <br />
              <div class="input-group" v-if="optionInfo.adjust_id">
                <span class="input-group-addon">分類</span>
                <button @click="goAdjust" class="form-control btn-primary btn" style="text-align: left">{{optionInfo.adjust_name}} <i class="fa fa-arrow-circle-right pull-right t-5" aria-hidden="true"></i></button>
              </div>
              <br>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-footer text-center">
      <button class="btn btn-default" @click="gotoOut">
        返回
      </button>
      <button
        v-if="!optionList.length"
        class="btn btn-success"
        @click="goCrOptions"
      >
        新增
      </button>
      <button class="btn btn-success" @click="checkInputEmpty" v-else>
        儲存
      </button>
    </div>
    <br />
    <m-modal
      class="text-left"
      :option="delOption"
      @trigger="trigger"
    />
  </div>
</template>

<script>
import $ from 'jquery'
import { mapActions, mapGetters } from 'vuex'

// views
import matcherModal from '../../../elements/Modal.vue'
import AdjustModal from './AdjustModal.vue'
import OptionModal from './OptionModal.vue'

// extends
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'CrOptionTemp',
  props: {
    'info': {
      type: Object
    }
  },
  components: {
    'adjust-modal': AdjustModal,
    'option-modal': OptionModal,
    'm-modal': matcherModal
  },
  extends: NdExtendHandleMenu,
  data () {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      show: {
        easy: true
      },
      current: {
        option: 0,
        adjust: 0,
        adjustId: 0,
        adjustName: '',
        adjustSubType: 0
      },
      brandName: '',
      brandType: '',
      adjustNumList: [],
      adjust: [],
      option: [],
      amount: {
        adjust: 1,
        option: 1
      },
      count: 20,
      maxTotal: 0,
      optionList: [],
      optionInfo: {
        sort: 0,
        name: '',
        vendor_custom_id: '',
        description: '',
        remark: '',
        price: '',
        price_type: '3',
        calorie: '',
        sub_type: 0,
        is_mandatory: '0',
        min_limit: 0,
        max_limit: 1,
        is_common: 0
      },
      subTypeList: [
        {value: 10, label: '大小(通用)'},
        {value: 12, label: 'S'},
        {value: 14, label: 'M'},
        {value: 16, label: 'L'},
        {value: 18, label: 'XL'},
        {value: 20, label: '容器(通用)'},
        {value: 30, label: '甜度(通用)'},
        {value: 31, label: '無糖'},
        {value: 33, label: '微糖'},
        {value: 35, label: '半糖'},
        {value: 37, label: '少糖'},
        {value: 39, label: '全糖'},
        {value: 40, label: '溫度(通用)'},
        {value: 42, label: '冰'},
        {value: 45, label: '溫'},
        {value: 48, label: '熱'},
        {value: 0, label: '未定義'},
        {value: 1, label: '自定義1'},
        {value: 2, label: '自定義2'},
        {value: 3, label: '自定義3'},
        {value: 4, label: '自定義4'},
        {value: 5, label: '自定義5'}
      ],
      oldInfo: {},
      curId: 0,
      delOption: {
        id: 'delModal',
        title: '刪除配料',
        body: '刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'del'
          }
        ]
      },
      defaultIndex: 1
    }
  },
  methods: {
    ...mapActions(['setUpAdjust', 'setModal']),
    clickOption (option, index) {
      this.curId = option.item_id
      this.defaultIndex = index + 1
    },
    delModalOpen () {
      this.delOption.title = `刪除${this.optionInfo.name}`
    },
    trigger (event) {
      if (event === 'del') {
        this.del(this.optionInfo.name)
      }
    },
    del (delName) {
      const url = this.base + this.id + '/option?option_id=' + this.optionInfo.option_id
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '成功刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getMenuOption('delete')
        }
      })
    },
    goAdjust () {
      let name = ''
      let params = {
        aId: this.optionInfo.adjust_id,
        brand_id: this.$route.params.brand_id,
        store_id: ''
      }

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuAdjust'
        params.store_id = this.$route.params.store_id
      } else {
        name = 'upAdjust'
      }

      this.$router.push({ name, params })
    },
    goCrOptions () {
      console.log('goCrOptions')
      let name = ''
      let params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      }

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuOptionCreate'
        params.store_id = this.$route.params.store_id
      } else {
        name = 'crOptions'
      }

      this.$router.push({ name, params })
    },
    init () {
      if (typeof this.info !== 'undefined') {
        this.brandName = this.info.name
        this.brandType = this.info.type
      }
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    openAdjustModal (adjust) {
      this.setModal(true)
      this.current.adjust = parseInt(adjust.adjust_id, 10)
      $('#infoAdjustModal').modal('toggle')
    },
    openOptionModal (type, name, aId, oId, aSubType) {
      this.setModal(true)
      this.current.adjustId = parseInt(aId, 10)
      this.current.adjustName = name
      this.current.optionId = parseInt(oId, 10)
      this.current.adjustSubType = aSubType
      this.setModal(true)
      if (type === 'cr') $('#crOptionModal').modal('toggle')
      else if (type === 'info') $('#infoOptionModal').modal('toggle')
    },
    gotoOut () {
      this.$router.go(-1)
    },
    checkInputEmpty () {
      if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫配料名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.min_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最低購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.max_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最高購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.upOption()
        return true
      }
    },
    upOption (type) {
      const url = this.base + this.id + '/option/' + this.curId
      let data = {}
      let oInfo = this.optionInfo
      let oldInfo = this.oldInfo
      if (type === 'sort') {
        data.sort = oInfo.sort
        data.price = oInfo.price
        data.max_limit = oInfo.max_limit
      } else {
        if (oInfo.sort !== oldInfo.sort) data.sort = oInfo.sort
        if (oInfo.name !== oldInfo.name) data.name = oInfo.name
        if (oInfo.vendor_custom_id !== oldInfo.vendor_custom_id) data.vendor_custom_id = oInfo.vendor_custom_id
        if (oInfo.description !== oldInfo.description) data.description = oInfo.description
        if (oInfo.remark !== oldInfo.remark) data.remark = oInfo.remark
        if (oInfo.price !== oldInfo.price) data.price = oInfo.price
        if (oInfo.price_type !== oldInfo.price_type) data.price_type = oInfo.price_type
        if (oInfo.sub_type !== oldInfo.sub_type) data.sub_type = oInfo.sub_type
        if (oInfo.calorie !== oldInfo.calorie) data.calorie = oInfo.calorie
        if (oInfo.is_mandatory !== oldInfo.is_mandatory) data.is_mandatory = oInfo.is_mandatory
        if (oInfo.min_limit !== oldInfo.min_limit) data.min_limit = oInfo.min_limit
        if (oInfo.max_limit !== oldInfo.max_limit) data.max_limit = oInfo.max_limit
        if (oInfo.is_common !== oldInfo.is_common) data.is_common = oInfo.is_common
      }
      if (JSON.stringify(data) !== '{}') {
        this.getDataH('put', url, data, (response) => {
          if (response.data.status === 200) {
            if (!type) {
              this.$notify({
                title: '提醒',
                text: '成功更新' + oInfo.name,
                duration: 3000,
                type: 'success',
                width: 400
              })
            }
            if (oInfo.name !== oldInfo.name) {
              this.getMenuOption('reload', oInfo.option_id)
              this.getOption()
            }
          }
        })
      }
    },
    copyOption () {
      const url = this.base + this.id + '/option/' + this.curId + '/duplicate'
      this.getDataH('post', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '成功複製配料',
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getMenuOption('clickOther', response.data.new_option_id)
        }
      })
    },
    getMenuOption (type, oId) {
      this.optionList = []
      const url = this.base + this.id + '/option/briefList?type=2'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            const optionList = response.data.list[0].child_list
            optionList.forEach((o2) => {
              o2.type = 2
              this.optionList.push(o2)
            })
            if (optionList.length || type === 'delete') {
              this.curId = optionList[0].item_id
            }
            if (type === 'clickOther') this.curId = oId
            this.getMenuOption2(type, oId)
          } else this.getMenuOption2(type, oId)
        }
      })
    },
    getMenuOption2 (oId) {
      const url = this.base + this.id + '/option/briefList?type=1'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            const adjustList = response.data.list
            adjustList.forEach((a) => {
              const optionList = a.child_list
              optionList.forEach((o) => {
                o.type = 1
                this.optionList.push(o)
              })
            })
            if (!this.curId) {
              if (oId) this.curId = parseInt(oId, 10)
              else this.curId = adjustList[0].child_list[0].item_id
            }
          }
        }
      })
    },
    getOption () {
      const url = this.base + this.id + '/option/' + this.curId
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          $.each(response.data.option, (index, value) => {
            this.$set(this.oldInfo, index, value)
          })
          this.optionInfo = response.data.option
          if (!this.optionInfo.sort || (!this.optionInfo.price && parseInt(this.optionInfo.price, 10) !== 0)) {
            this.optionInfo.sort = this.defaultIndex
            this.optionInfo.price = 0
            this.optionInfo.max_limit = 1
            this.upOption('sort')
          }
        }
      })
    },
    optionByAId (adjustId, index) {
      let page = 1
      if (index) page = index
      if (adjustId) {
        const url = this.base + this.id + '/adjust/' + adjustId + '/optionlist?page=' + page + '&size=' + this.count
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            var adjustId = response.data.meta.adjust_id
            this.adjust.filter((elem) => {
              if (elem.adjust_id === adjustId) {
                this.$set(elem, 'option_list', response.data.option_list)
                this.$set(elem, 'option_total', response.data.meta.total)
                this.$set(elem, 'page', page)
              }
              return elem.adjust_id === adjustId
            })
          }
        })
      }
    },
    checkAllOptions (adjust) {
      let aMin = adjust.min_limit
      let oList
      let oAllMax = 0
      if (adjust.option_list) {
        oList = adjust.option_list
        for (let i = 0; i < oList.length; i++) {
          oAllMax = oAllMax + oList[i].max_limit
        }
      }
      if (aMin > oAllMax) return aMin - oAllMax
      else return false
    },
    pageShow (index) {
      const num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    veritySort () {
      const e = $(this.$refs.sort)
      this.optionInfo.sort = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityMinLimit () {
      const e = $(this.$refs.minLimit)
      this.optionInfo.min_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityMaxLimit () {
      const e = $(this.$refs.maxLimit)
      this.optionInfo.max_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityPrice () {
      const e = $(this.$refs.price)
      this.optionInfo.price = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[-]?[0-9]*/))
      }
    },
    verityCalorie () {
      const e = $(this.$refs.calorie)
      this.optionInfo.calorie = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    }
  },
  created () {
    this.getMenuOption()
  },
  computed: {
    ...mapGetters(['getUpAdjust', 'getModal', 'getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    },
    productNew () {
      const product = this.product
      return product
    },
    pageAmount () {
      return Math.ceil(this.maxTotal / this.count)
    },
    allInput () {
      const info = this.optionInfo
      return {
        name: this.checkInput(info.name),
        sort: this.checkInput(info.sort),
        vendor_custom_id: this.checkInput(info.vendor_custom_id),
        description: this.checkInput(info.description),
        remark: this.checkInput(info.remark),
        price: this.checkInput(info.price),
        price_type: parseInt(info.price_type, 10),
        calorie: this.checkInput(info.calorie),
        min_limit: this.checkInput(info.min_limit),
        max_limit: this.checkInput(info.max_limit)
      }
    }
  },
  watch: {
    getUpAdjust () {
      if (this.getUpAdjust) {
        this.adjustNumList = []
        this.getMenuAdjust(1)
      }
    },
    getModal () {
      if (!this.getModal) {
        this.current = {
          option: 0,
          adjust: 0,
          adjustId: 0,
          adjustName: '',
          adjustSubType: 0
        }
      }
    },
    curId () {
      this.getOption()
    }
  }
}
</script>

<style lang="sass" scoped>
$default-color: #e1456d
$light-gray: rgb(238, 238, 238)
$primary-color: #3c8dbc

.t-5
  top: 5px
.btn-black, .btn-black:hover, .btn-black:focus, .btn-black:active, .btn-black:active:focus
  border: 1px solid #333333 !important
.m-r-10
  margin-right: 10px
.p-r-5
  padding-right: 5px !important
.p-l-5
  padding-left: 5px !important
.box-body.menu-form
  left: 0
  width: auto
  padding: 0px 10px
.btn-options
  width: 100%
  padding: 8px 0px
  color: $default-color
  background: #ffffff
  border: solid 1px $default-color
  border-radius: 5px
.btn.disabled, .btn[disabled], fieldset[disabled] .btn
  cursor: auto
  opacity: 1
.c-auto
  cursor: auto !important
.label-notice-number
  background: #e1456d
  border-radius: 5px
  font-size: 15px
  color: #fff
  padding: 4px 12px
  font-weight: bold
  top: -2px
.bg-light-gray
  background: $light-gray
.select-element
  padding: 10px 15px
  cursor: pointer
  border-bottom: 2px solid #ddd
.select-element:last-child
  border-bottom: 0px
.select-element:hover, .select-element.active
  background: $primary-color
  color: #fff
.select-element-block
  margin-bottom: 10px
  max-height: calc(100vh - 360px)
  overflow: scroll
@media screen and (max-width: 767px)
  .select-element
    padding: 5px 15px
    font-size: 16px
  .select-element-block
    margin-left: 10px
    margin-right: 10px
    height: 30vh
</style>



// WEBPACK FOOTER //
// CrOptionTemp.vue?0b8a370e